/* eslint-disable import/prefer-default-export */
import { select } from 'redux-saga/effects';
import selectors from '@/selectors';
import { findQuery } from './state/shared';

export function* getCohortSourceProps(action) {
  const items = yield select(selectors.cohorts);
  const { cohort } = findQuery(items, action);

  return {
    isEditing: !!cohort?.isEditing,
    isSystem: !!cohort?.system,
  };
}
